import React, { useState, useEffect } from 'react';
import { FaCopy, FaEnvelope, FaWhatsapp, FaSms, FaFacebook, FaTimes, FaShareAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getUserReferralCodeCall } from "../../api/apiOperations";

const ReferralSection: React.FC = () => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const [referralCode, setReferralCode] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserReferralCodeCall()
      .then((res: any) => setReferralCode(res?.referralCode || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const referralMessage = `Join me on JackedRabbit and use my code ${referralCode} to get $25 off your first month! https://jackedrabbitgyms.com/`;

  const handleCopy = () => {
    if (!referralCode) return;
    navigator.clipboard.writeText(referralCode).then(() => {
      setCopied(true);
      toast.success('Code copied!');
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const handleShare = (platform: string) => {
    const urls: Record<string, string> = {
      email: `mailto:?subject=Join%20JackedRabbit&body=${encodeURIComponent(referralMessage)}`,
      sms: `sms:?&body=${encodeURIComponent(referralMessage)}`,
      whatsapp: `https://wa.me/?text=${encodeURIComponent(referralMessage)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://jackedrabbitgyms.com/')}`,
      x: `https://x.com/intent/tweet?text=${encodeURIComponent(referralMessage)}`,
    };
    if (urls[platform]) window.open(urls[platform], '_blank');
  };

  if (loading) return null;

  return (
    <>
      {/* ── Referral card matching mobile style ── */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '20px', padding: '24px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)', width: '100%',
      }}>
        <p style={{ fontSize: '11px', fontWeight: 700, color: '#9CA3AF', letterSpacing: '1.5px', textTransform: 'uppercase', margin: '0 0 10px' }}>
          REFER A FRIEND
        </p>
        <h3 style={{ fontSize: '22px', fontWeight: 800, color: '#1a1a1a', margin: '0 0 8px', letterSpacing: '-0.3px' }}>
          Give $25, Get $25
        </h3>
        <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.6, margin: '0 0 18px' }}>
          You get $25 credit. They get $25 off their first month.
        </p>

        {referralCode ? (
          <>
            {/* Code block */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              backgroundColor: '#f5f5f5', borderRadius: '12px', padding: '12px 16px', marginBottom: '14px',
            }}>
              <span style={{ fontSize: '22px', fontWeight: 700, fontFamily: 'monospace', letterSpacing: '3px', color: '#1a1a1a' }}>
                {referralCode}
              </span>
              <button onClick={handleCopy} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#555', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 600 }}>
                {/* @ts-ignore */}
                <FaCopy size={16} />
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            {/* Share button */}
            <button onClick={() => setShowShareModal(true)} style={{
              width: '100%', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
              borderRadius: '30px', padding: '14px', fontSize: '15px', fontWeight: 700,
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            }}>
              {/* @ts-ignore */}
              <FaShareAlt size={15} />
              Share JackedRabbit
            </button>
          </>
        ) : (
          <p style={{ fontSize: '13px', color: '#9CA3AF', margin: 0 }}>
            Active members can refer friends to get $25 off. Check back later!
          </p>
        )}
      </div>

      {/* ── Share modal ── */}
      {showShareModal && (
        <div onClick={() => setShowShareModal(false)} style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px',
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            backgroundColor: '#faf6f1', borderRadius: '24px', padding: '28px 24px',
            maxWidth: '400px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: 800, color: '#1a1a1a', margin: 0 }}>Share Your Code</h3>
              <button onClick={() => setShowShareModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}>
                {/* @ts-ignore */}
                <FaTimes size={18} color="#555" />
              </button>
            </div>

            <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.6, margin: '0 0 16px' }}>
              Give your friends $25 off their first month. When they join, you get $25 credit.
            </p>

            {/* Code */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: '12px', padding: '12px 16px', marginBottom: '20px', border: '1px solid #e8e2dc' }}>
              <span style={{ fontSize: '20px', fontWeight: 700, fontFamily: 'monospace', letterSpacing: '3px', color: '#1a1a1a' }}>{referralCode}</span>
              <button onClick={handleCopy} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#555', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 600 }}>
                {/* @ts-ignore */}
                <FaCopy size={14} />
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            {/* Share options */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
              {[
                { key: 'email', label: 'Email', Icon: FaEnvelope, bg: '#D44638' },
                { key: 'sms', label: 'SMS', Icon: FaSms, bg: '#4CAF50' },
                { key: 'whatsapp', label: 'WhatsApp', Icon: FaWhatsapp, bg: '#25D366' },
                { key: 'facebook', label: 'Facebook', Icon: FaFacebook, bg: '#1877F2' },
              ].map(({ key, label, Icon, bg }) => (
                <button key={key} onClick={() => handleShare(key)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '12px', backgroundColor: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {/* @ts-ignore */}
                    <Icon size={20} color="#fff" />
                  </div>
                  <span style={{ fontSize: '11px', color: '#555', fontWeight: 500 }}>{label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReferralSection;
